import { SxProps, Theme } from '@mui/material';

type TStyles = {
  infoIcon: (theme: Theme) => SxProps<Theme>;
  modalPaper: SxProps<Theme>;
  tariffListItem: SxProps<Theme>;
  tariffList: SxProps<Theme>;
  buttonGrid: SxProps<Theme>;
};

export const styles: TStyles = {
  modalPaper: (theme: Theme) => ({
    width: theme.spacing(90),
    p: theme.spacing(3),
    m: theme.spacing(2),
  }),
  tariffListItem: (theme: Theme) => ({
    '&::before': {
      content: '"•"',
      fontSize: 12,
      mr: 0.5,
    },
    color: theme.palette.primary.main,
    p: 0,
  }),
  tariffList: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    pl: theme.spacing(1),
  }),
  infoIcon: (theme: Theme) => ({
    position: 'absolute',
    right: theme.spacing(-3),
    top: theme.spacing(-1.5),
  }),
  buttonGrid: (theme: Theme) => ({
    gap: '10px',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  }),
};
